export default "__VITE_ASSET__C9Gy4EBB__"